<style lang="scss" scoped>
@import "./scss/Public.scss";
</style>

<template>
  <div class="profit-box">
    <div class="title-box">
      <h3>{{report.title}}</h3>
    </div>
    <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
      <profit-table
        :thData="thData"
        :trData="trData"
        :page="page"
        :selPage="selPage"
        :curArea="curArea"
        :name="name"
        :multiLanguage="report"
        :jsonExcelAjax="jsonExcelAjax"
        @tableChange="requestHandle"
      >
        <div slot="handle" class="conditions">
          <div class="condition">
            <span>{{report.begin}}</span>
            <el-select v-model="idFrom" filterable style="width: 120px;">
              <el-option v-for="(key,val) in report_id_list" :key="val" :label="key" :value="val"></el-option>
            </el-select>
            &nbsp;{{report.to}}&nbsp;
            <el-select v-model="idTo" filterable style="width: 120px;">
              <el-option v-for="(key,val) in report_id_list" :key="val" :label="key" :value="val"></el-option>
            </el-select>
          </div>
          <div class="condition change-el-input-group-style">
            <el-input v-model="searchVal">
              <el-select v-model="searchKey" slot="prepend" style="width: 105px;">
                <el-option
                  v-for="(item, index) in report.selectArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" @click="searchHandle">{{report.search}}</el-button>
            </el-input>
          </div>
        </div>
      </profit-table>
    </div>
  </div>
</template>

<script>
import { formatDate } from "common/js/util";
import ProfitTable from "./ProfitTable";
import { URL_SHARE_REPORT } from "api/commissionApi";
let data = () => {
  return {
    loading: false,
    trData: [],
    searchKey: "LOGIN",
    searchVal: "",
    idFrom: "",
    idTo: "",
    report_id_list: {},
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    }
  };
};

const mounted = function() {
  this.$http
    .get(URL_SHARE_REPORT, {
      params: { area: this.curArea, searchKey: "list" }
    })
    .then(res => {
      const list = res.data.data;
      if (list.length == 0) return;
      this.idFrom = list[0].REPORT_ID;
      this.idTo = list[0].REPORT_ID;
      list.forEach(v => (this.report_id_list[v.REPORT_ID] = v.REPORT_ID));
      this.requestHandle();
    })
    .catch(e => alert(e));
};

const methods = {
  searchHandle() {
    this.page.active = 1;
    this.requestHandle();
  },
  requestHandle() {
    this.loading = true;
    let obj = {
      params: {
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        idFrom: this.idFrom,
        idTo: this.idTo,
        area: this.curArea,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      }
    };
    this.$http.get(URL_SHARE_REPORT, obj).then(res => {
      this.trData = res.data.data.rows;
      this.page.pageLeng = res.data.data.count;
      this.loading = false;
    });
  }
};

const props = {
  curArea: {
    type: String,
    required: true
  }
};

const mixins = [
  require("common/mixin/base.js").base({ report: "profitShareReport" })
];

const computed = {
  thData() {
    return this.report.first_row;
  },
  jsonExcelAjax() {
    return {
      url: URL_SHARE_REPORT,
      ajaxType: "get",
      getKey: ["data", "data", "rows"],
      ajaxPar: {
        pageSize: this.page.pageLeng,
        pageNum: 0,
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        idFrom: this.idFrom,
        idTo: this.idTo,
        area: this.curArea
      }
    };
  },
  name() {
    return this.report.title;
  }
};

const watch = {
  curArea() {
    this.page.active = 1;
    this.ib_id = "";
    this.requestHandle();
  }
};

const components = { ProfitTable };

export default {
  data,
  mounted,
  methods,
  props,
  mixins,
  computed,
  watch,
  components
};
</script>



// WEBPACK FOOTER //
// ProfitShareReport.vue?a6caf288